<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity end line (second line in a block)          -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row v-if="dutyActivity.longname || dutyActivity.note" dense class="DutyActivityEnd_RhB">
    <v-col cols="8" class="ml-0 pl-0">{{ dutyActivity.longname }} &nbsp;{{ dutyActivity.note }}</v-col>
    <v-col cols="4"></v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityEnd_RhB',

  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {},
};
</script>
